"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const AnchoredDropdown = ({ className, children, visible = false, onClose }) => {
    const dropdownRef = (0, react_1.useRef)(null);
    const closeClickHandler = (0, react_1.useMemo)(() => (event) => {
        const clickedInside = dropdownRef.current?.contains(event.target);
        if (clickedInside) {
            return;
        }
        onClose();
    }, []);
    const closeEscHandler = (0, react_1.useMemo)(() => (event) => {
        if ('Escape' === event.key) {
            onClose();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (visible) {
            setTimeout(() => {
                document.addEventListener('click', closeClickHandler);
                window.addEventListener('keyup', closeEscHandler);
            });
        }
        else {
            document.removeEventListener('click', closeClickHandler);
            window.removeEventListener('keyup', closeEscHandler);
        }
        return () => {
            document.removeEventListener('click', closeClickHandler);
            window.removeEventListener('keyup', closeEscHandler);
        };
    }, [visible]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-anchored-dropdown', className, { 'znd-anchored-dropdown__visible': visible }), ref: dropdownRef }, children));
};
exports.default = AnchoredDropdown;
